var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-container"},[_c('div',{staticClass:"upload-btn mx-auto pointer",class:{'disabled': _vm.isDisable},on:{"click":function($event){_vm.isDisable ? '' : _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.$t("add_image")))])])}
var staticRenderFns = []

export { render, staticRenderFns }